<template>

  <div
    class="bullet"
    :class="status"
    v-tooltip="title">
  </div>

</template>

<script>
export default {
  name: 'Bullet',
  props: {
    status: {
      type: String,
      default: 'secondary'
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bullet{
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background: rgb(0, 123, 255);
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
}
  .bullet.primary{
    background: rgb(0, 123, 255);
  }
  .bullet.secondary{
    background: rgb(108, 117, 125);
  }
  .bullet.success{
    background: rgb(40, 167, 69);
  }
  .bullet.danger{
    background: rgb(220, 53, 69);
  }
  .bullet.warning{
    background: rgb(255, 193, 7);
  }
  .bullet.info{
    background: rgb(23, 162, 184);
  }
  .bullet.light{
    background: rgb(248, 249, 250);
  }
  .bullet.dark{
    background: rgb(52, 58, 64);
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/Bullet.vue